import type { ReactNode } from 'react';

import { BrandMark, BrandWord } from '@/components/ui';
import { cn } from '@/lib/utils';

/*
  Кольори — токени brand-mark / brand-word: у темній темі це білий варіант
  з того самого набору, а не перефарбування. Контури — у @sirius/ui.
*/

/** Знак + напис SIRIUS + «HUB». Дескриптор «CAR SHIPPING» замінено рішенням 2026-09-11. */
export function BrandLogo({ className, compact = false }: { className?: string; compact?: boolean }): ReactNode {
	/*
	  `compact` лишає на вузькому екрані сам знак. Потрібен у смузі робочої
	  зони: там поруч із логотипом стоять бургер, дзвіночок і чип користувача,
	  і повний напис (219px) виштовхував чип за правий край — сторінка
	  отримувала горизонтальну прокрутку. Приховані діти не створюють проміжків
	  flex, тому окремо гасити `gap-3` не треба.
	*/
	const wide = compact ? 'hidden sm:block' : undefined;

	return (
		<span className={cn('flex items-center gap-3', className)}>
			<BrandMark className="size-8.5 fill-brand-mark" />
			<BrandWord className={cn('h-4 w-27 fill-brand-word', wide)} />
			<span
				className={cn(
					'border-l border-border py-0.5 pl-3 font-display text-xs font-medium tracking-[0.22em] text-primary',
					wide,
				)}
			>
				HUB
			</span>
		</span>
	);
}
